import React from 'react';
import { Box, Typography, Container, Grid, useTheme } from '@mui/material';
import { Search as SearchIcon, LibraryBooks as LibraryBooksIcon, CloudDownload as CloudDownloadIcon } from '@mui/icons-material';

const features = [
    {
        icon: <SearchIcon sx={{ fontSize: '4rem', color: 'white' }} />,
        title: 'Ask Questions',
        description: 'Get instant answers and clarification on any concept.',
    },
    {
        icon: <LibraryBooksIcon sx={{ fontSize: '4rem', color: 'white' }} />,
        title: 'Create Notes',
        description: 'Take and organize your notes for easy reference later.',
    },
    {
        icon: <CloudDownloadIcon sx={{ fontSize: '4rem', color: 'white' }} />,
        title: 'Generate PDFs',
        description: 'Save your generated content in a downloadable PDF format.',
    },
];

const Hero = () => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                background: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
                color: 'primary.contrastText',
                padding: theme.spacing(8, 2),
                textAlign: 'center',
            }}
        >
            <Container maxWidth="lg">
                {/* Beta Announcement Banner */}
                <Box
                    sx={{
                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                        borderRadius: theme.spacing(1),
                        padding: theme.spacing(2),
                        marginBottom: theme.spacing(4),
                        boxShadow: `0 0 10px rgba(0, 0, 0, 0.2)`,
                    }}
                >
                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: 600,
                            fontSize: { xs: '1rem', sm: '1.25rem' },
                            color: 'white',
                        }}
                    >
                        <span
                            style={{
                                display: 'inline-block',
                                animation: 'flyingAnimation 2s ease-in-out infinite',
                                marginRight: theme.spacing(1),
                            }}
                        >
                            🚀
                        </span>
                        Welcome to the Beta Version of Glassyfied!
                    </Typography>

                    <Typography
                        variant="body2"
                        sx={{
                            color: 'white',
                            opacity: 0.9,
                            marginTop: theme.spacing(1),
                            fontSize: { xs: '0.9rem', sm: '1rem' },
                        }}
                    >
                        The current window is open for{' '}
                        <span
                            style={{
                                fontWeight: 'bold',
                                color: theme.palette.primary.main,
                                background: 'linear-gradient(45deg, #FF7E5F, #FEB47B)', // Gradient effect
                                backgroundClip: 'text', // Ensures the gradient only applies to text
                                WebkitBackgroundClip: 'text', // For Safari support
                                color: 'transparent', // Makes the text color transparent to show gradient
                                textShadow: '0 2px 5px rgba(0, 0, 0, 0.5)', // Softer shadow for better legibility
                                fontSize: '1.2em', // Increased font size
                                textDecoration: 'underline', // Adds underline for emphasis
                            }}
                        >
                            exclusive free access
                        </span>. Users joining during this period will receive special access to the product!

                    </Typography>
                </Box>

                {/* Heading and Subheading */}
                <Typography
                    variant="h2"
                    sx={{
                        fontWeight: 700,
                        fontSize: { xs: '2rem', sm: '3rem', md: '4rem' },
                        marginBottom: theme.spacing(2),
                    }}
                >
                    Clear Your Concepts with Glassyfied
                </Typography>

                <Typography
                    variant="h6"
                    sx={{
                        fontWeight: 400,
                        marginBottom: 4,
                        fontSize: { xs: '1rem', sm: '1.25rem' },
                        margin: '0 auto',
                        color: 'primary.contrastText',
                    }}
                >
                    Ask questions, clarify your concepts, create notes, and generate personalized content using the power of AI.
                    Whether you're a student, educator, or academic professional, Glassyfied helps you learn smarter.
                </Typography>

                {/* Features Section */}
                <Box sx={{ marginTop: 6 }}>
                    <Grid container spacing={4} justifyContent="center">
                        {features.map((feature, index) => (
                            <Grid item xs={12} sm={3} key={index}>
                                <Box sx={{ textAlign: 'center' }}>
                                    {feature.icon}
                                    <Typography variant="h6" sx={{ color: 'white', marginTop: theme.spacing(1) }}>
                                        {feature.title}
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: 'white', opacity: 0.7 }}>
                                        {feature.description}
                                    </Typography>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </Container>
        </Box>
    );
};

export default Hero;
